<template>
  <div class="py-2">
    <h3 class="ui dividing header fdinpro default-header-green is-uppercase">
      {{ $t("historico de envios") }}
    </h3>
    <div
      class="fluid ui button sb-button"
      v-for="(bundle, index) in bundles"
      v-bind:class="{ active: selected_bundle == bundle }"
      :key="index"
      @click="select_bundle(bundle)"
    >
      <div class="pre-sb-button">{{ bundle.requests_count }}</div>
      <div class="name-sb-button">{{ bundle.setup.name }}</div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "NvidiaTicketStoreBundleList",
  data() {
    return {
      bundles: [],
      selected_bundle: undefined,
    };
  },
  created() {
    let vm = this;
    vm.init();
  },
  methods: {
    select_bundle(bundle) {
      let vm = this;
      vm.selected_bundle = bundle;
      vm.$emit("bundle_change", bundle);
    },
    refresh() {
      this.init();
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/nworkforce/store/do-get-active-bundle-list", {
        d: vm.d,
      })
        .then(function(r) {
          vm.bundles = r.bundles;
          vm.$emit("set_stores", r.stores);
          vm.$emit("set_bundles", r.bundles);
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}
</style>
